export const BITBUCKET_BUILD_NUMBER = 1387;
